<template>
  <b-form ref="form" >
    <div class="row">
      <div class="row col-12 pr-0 mb-3">
        <span>Are you sure you want to delete {{ name }}?</span>
      </div>
    </div>
  </b-form>
</template>

<script>

export default {
  components: {
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    experienceLevelID() {
      let parameters = this.parameters || {}
      return parameters.experienceLevelID
    },
    submitted() {
      let parameters = this.parameters || {}
      return parameters.submitted
    }
  },
  data () {
    return {
      name: '',
      model: {}
    }
  },
  methods: {
    fetchExperienceLevel() {
      let id = this.experienceLevelID;
      if (!id) return;

      return this.$store.dispatch('experience_level/find', { id })
      .then(result => {
        if (result && result.data) {
          this.model = result.data;
          this.name = result.data.name;
        }
      })
      .catch(err => console.log(err))
    }
  },
  mounted() {
    if (this.experienceLevelID) {
      this.fetchExperienceLevel();
    }
  },
}
</script>